import { Modal } from "react-bootstrap";
import {
  LAST_3_PAYSLIPS,
  REQUIRED_DOCUMENTS,
  lastThreePayslipMonths,

  SECTION_TITLES,
} from "../../utils/requiredDocuments";

const SECTION_KEYS = Object.keys(SECTION_TITLES);

const heading = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "#6b7280",
};

function List({ label, docs, tone }) {
  if (!docs.length) return null;
  return (
    <div className="mb-2">
      <div style={{ fontSize: 12, fontWeight: 600, color: tone }}>{label}</div>
      <ul className="mb-0 ps-3" style={{ fontSize: 13 }}>
        {docs.map((doc) => (
          <li key={doc}>
            {doc}
            {doc === LAST_3_PAYSLIPS && (
              <span className="text-muted">
                {" "}
                (one per month: {lastThreePayslipMonths().join(", ")})
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function RequiredDocumentsModal({ onClose }) {
  return (
    <Modal show onHide={onClose} centered size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Basic documents</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted" style={{ fontSize: 13 }}>
          Documents Skor requests for each employment type. Compulsory ones
          count as missing until uploaded; additional ones are accepted but
          never counted as missing.
        </p>
        {REQUIRED_DOCUMENTS.map((entry) => (
          <section key={entry.label} className="mb-4">
            <h3 className="h6 fw-bold border-bottom pb-2">{entry.label}</h3>
            {SECTION_KEYS.map((key) => {
              const section = entry[key];
              if (!section) return null;
              // identification is a plain list in the frontend (no split)
              if (Array.isArray(section)) {
                if (!section.length) return null;
                return (
                  <div key={key} className="mb-3">
                    <div style={heading}>{SECTION_TITLES[key]}</div>
                    <List label="Accepted" docs={section} tone="#6b7280" />
                  </div>
                );
              }
              const { compulsory, additional } = section;
              if (!compulsory.length && !additional.length) return null;
              return (
                <div key={key} className="mb-3">
                  <div style={heading}>{SECTION_TITLES[key]}</div>
                  <List label="Compulsory" docs={compulsory} tone="#2f6b12" />
                  <List label="Additional" docs={additional} tone="#6b7280" />
                </div>
              );
            })}
          </section>
        ))}
      </Modal.Body>
    </Modal>
  );
}
